import React from "react";

import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/payment.css";
import { pymnt1, pymnt2, pymnt3, pymnt4, visa, visa2 } from "../../constants";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Payment = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-7">
							<Logout />
							<section className="checkout checkout-payment">
								<div className="container">
									<form action="/Thankyou">
										<div className="row">
											<div className="col-lg-10">
												<div className="payment-details">
													<div className="heading">
														<h3>Payment</h3>
													</div>
													<div className="saved-payment-method">
														<div className="add-new-method">
															<div className="form-group">
																<input
																	type="text"
																	placeholder="Card Number"
																	className="form-control"
																/>
																<input
																	type="text"
																	placeholder="mm/yy"
																	className="form-control"
																/>
																<input
																	type="text"
																	placeholder="cvc"
																	className="form-control"
																/>
															</div>
														</div>
														<div className="type-and-card-wrapper">
															<div className="card-type">
																<label className="container">
																	<input
																		type="radio"
																		checked="checked"
																		name="radio"
																	/>
																	<span className="checkmark">
																		<figure>
																			<img src={pymnt1} className="img-fluid" />
																		</figure>
																	</span>
																</label>
																<label className="container">
																	<input type="radio" name="radio" />
																	<span className="checkmark">
																		<figure>
																			<img src={pymnt2} className="img-fluid" />
																		</figure>
																	</span>
																</label>
																<label className="container">
																	<input type="radio" name="radio" />
																	<span className="checkmark">
																		<figure>
																			<img src={pymnt3} className="img-fluid" />
																		</figure>
																	</span>
																</label>
																<label className="container">
																	<input type="radio" name="radio" />
																	<span className="checkmark">
																		<figure>
																			<img src={pymnt4} className="img-fluid" />
																		</figure>
																	</span>
																</label>
															</div>
															{/* <!-- Saved payments Method --> */}
															<div className="btn-wrapper">
																<button className="btn">Add Card</button>
															</div>
														</div>
													</div>
												</div>
												<div className="payment-details">
													<div className="heading">
														<h3>Saved Cards</h3>
													</div>
													<div className="saved-payment-method">
														{/* <!-- Saved payments Method --> */}
														<label className="container second-card">
															<input type="radio" name="payment-radio" />
															<span className="checkmark">
																<div className="card-details">
																	<div className="radio-btn">
																		<h6 className="def">Use as default</h6>
																		<span></span>
																	</div>
																	<div className="visa-card">
																		<div className="img-box">
																			<figure>
																				<img src={visa2} alt="No Image Found" />
																			</figure>
																		</div>
																		<div className="input-box">
																			<label for="card-number">
																				My Personal Card
																			</label>
																			<input
																				id="card-number"
																				value="**********1239"
																				type="text"
																				readonly=""
																			/>
																		</div>
																	</div>
																	<div className="extra-btn">
																		<i className="fa-solid fa-trash-can"></i>
																		{/* <div className="selection">
                                      <i
																				className="fa fa-check"
																				aria-hidden="true"
																			></i>
                                    </div> */}
																	</div>
																</div>
															</span>
														</label>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</section>
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Payment;
